import { Main } from './components';

export const BankAccounts = () => {
  return <Main />;
};

